module.exports = __webpack_public_path__ + "static/media/ic_document_mobile.eefa98f7.svg";